var recaptcha = (function (GlobalSettings) {

    var $result = new $.Deferred();
    var $ready = null;

    window.recaptchaResult = function(token) {
        window.app && app.events && app.events.recaptcha.receivetoken();
        $result.resolve(token);
    }

    return {
        init: function(elementID) {

            if ($ready) return $ready.promise();

            $ready = new $.Deferred();

            if (!GlobalSettings.RCE) {
                return $ready.resolve().promise();
            }

            $.getScript('https://www.google.com/recaptcha/api.js')
                .then(function() {
                    setTimeout(function() {
                        window.grecaptcha.ready(function() {
                            window.grecaptcha.render(elementID, {
                                'sitekey' : GlobalSettings.RCK,
                                'size': 'invisible',
                                callback: 'recaptchaResult'
                            });

                            setTimeout(function() {
                                if ($('#' + elementID).find('#g-recaptcha-response').length) {
                                    $ready.resolve();
                                } else {
                                    $('#' + elementID).remove();
                                    $ready.reject();
                                }
                            }, 100);

                        });
                    }, 100);
                });
            return $ready.promise();
        },
        execute: function() {
            $result = new $.Deferred();

            if (!GlobalSettings.RCE) {
                return $result.resolve("").promise();
            }
            
            window.app && app.events && app.events.recaptcha.requesttoken();
            window.grecaptcha.reset();

            window.grecaptcha.execute();
            return $result.promise();
        }
    };
})(window.app && app.GlobalSettings || window.GlobalSettings);